import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../_services/langhfre.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-grammar-checker-tool',
  templateUrl: './grammar-checker-tool.component.html',
  styleUrls: ['./grammar-checker-tool.component.scss']
})
export class GrammarCheckerToolComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const header = document.querySelector('app-header');
      const footer = document.querySelector('app-footer');

      if (header) {
        this.renderer.setStyle(header, 'display', 'none');
      }

      if (footer) {
        this.renderer.setStyle(footer, 'display', 'none');
      }
      this.renderer.addClass(document.body, 'hide-back-to-top');
    }
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/grammar-checker-tool' });
    this.metaTagService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      const header = document.querySelector('app-header');
      const footer = document.querySelector('app-footer');

      if (header) {
        this.renderer.setStyle(header, 'display', 'none');
      }

      if (footer) {
        this.renderer.setStyle(footer, 'display', 'none');
      }
      this.renderer.addClass(document.body, 'hide-back-to-top');
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      const header = document.querySelector('app-header');
      const footer = document.querySelector('app-footer');

      if (header) {
        this.renderer.removeStyle(header, 'display');
      }

      if (footer) {
        this.renderer.removeStyle(footer, 'display');
      }
      this.renderer.removeClass(document.body, 'hide-back-to-top');
    }
  }

}
